export const PREFIXES = [
    {
        id: '',
        value: 'None'
    },
    {
        id: 'RM-',
        value: 'Room'
    }
];